import { render, staticRenderFns } from "./ClientMenu.vue?vue&type=template&id=0f12ce72&scoped=true&"
import script from "./ClientMenu.vue?vue&type=script&lang=js&"
export * from "./ClientMenu.vue?vue&type=script&lang=js&"
import style0 from "./ClientMenu.vue?vue&type=style&index=0&id=0f12ce72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12ce72",
  null
  
)

export default component.exports